exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".p-10 {\n  padding: 10px; }\n\n.my-10 {\n  margin-top: 10px;\n  margin-bottom: 10px; }\n\n.border {\n  border: 2px solid rgba(170, 170, 170, 0.5); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/module/project/panel/panel.component.scss
// module id = 467
// module chunks = 0